import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {categoriesFeatureKey, CategoriesState} from "./categories.reducer";

export const getCategoriesState = createFeatureSelector<CategoriesState>(categoriesFeatureKey);

export const getCategories = createSelector(getCategoriesState, (state) => state.data);
export const getCategoriesLoading = createSelector(getCategoriesState, SelectorUtil.isLoading);
